import React from 'react';
import { Button } from './Button';
import { Icon } from './Icon';
import { useLanguage } from '../contexts/LanguageContext';
import { FANVUE_PROFILE_URL } from '../utils/fanvue';
export function Bio() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 md:py-32 px-6 bg-gradient-to-b from-[#0a0a0a] to-[#1a1a1a]" data-id="element-32" data-mp="115e4mzm8qt9">
      <div className="max-w-7xl mx-auto" data-id="element-33" data-mp="3t68vxasy4kow">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center" data-id="element-34" data-mp="35g6b9frd2h0b">
          {/* Text Content - Centered on Mobile */}
          <div className="order-2 lg:order-1 animate-fade-in text-center lg:text-left" data-id="element-35" data-mp="30id3iiaetexx">
            <span className="inline-block text-[#C5A028] text-xs font-medium tracking-[0.2em] uppercase mb-4" data-id="element-36" data-mp="3e9i7txoq2vel">
              {t('bio.label')}
            </span>

            <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-6 tracking-tight leading-[1.15]" data-id="element-37" data-mp="2ls5v6ve49cay">
              Alexaaa Narvaez
            </h2>

            <p className="text-base md:text-lg text-white/60 font-light leading-relaxed mb-5" data-id="element-38" data-mp="2hqbw2rjkkgcw">
              {t('bio.description1')}
            </p>

            <p className="text-sm md:text-base text-white/50 font-light leading-relaxed mb-8" data-id="element-39" data-mp="1h5ml3ajys85r">
              {t('bio.description2')}
            </p>

            <div className="space-y-4 mb-10 pb-10 border-b border-white/10" data-id="element-40" data-mp="1lxmr9kqmnxas">
              <div className="flex items-start gap-4 text-left" data-id="element-41" data-mp="1qumn72trjjo6">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-42" data-mp="t8flc0oug5fi">
                  <Icon name="camera" size={18} className="text-[#C5A028]" data-id="element-43" data-mp="y8bltpyc1eqb" />
                </div>
                <div data-id="element-44" data-mp="135btg5atypjj">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-45" data-mp="134sdgu4qqb85">
                    {t('bio.feature1.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-46" data-mp="2elijac595118">
                    {t('bio.feature1.desc')}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 text-left" data-id="element-47" data-mp="2jmg0aleizp15">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-48" data-mp="jgsphtykrlcv">
                  <Icon name="film" size={18} className="text-[#C5A028]" data-id="element-49" data-mp="eln4cxczyapu" />
                </div>
                <div data-id="element-50" data-mp="sgxtrv8h23mt">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-51" data-mp="ohq6423xs7c9">
                    {t('bio.feature2.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-52" data-mp="snq0yoyamjv">
                    {t('bio.feature2.desc')}
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4 text-left" data-id="element-53" data-mp="9l7rs80jh78x">
                <div className="w-10 h-10 rounded-sm bg-[#C5A028]/10 flex items-center justify-center flex-shrink-0 mt-1" data-id="element-54" data-mp="4tprlm6cbap0">
                  <Icon name="sparkle" size={18} className="text-[#C5A028]" data-id="element-55" data-mp="3d8hjsuuna36e" />
                </div>
                <div data-id="element-56" data-mp="398h6jdja7y0x">
                  <h3 className="text-white text-sm font-medium mb-1" data-id="element-57" data-mp="39763xh1kowbe">
                    {t('bio.feature3.title')}
                  </h3>
                  <p className="text-white/50 text-sm font-light leading-relaxed" data-id="element-58" data-mp="33uh5a7ld08l2">
                    {t('bio.feature3.desc')}
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Centered on Mobile, Full Width */}
            <div className="flex justify-center lg:justify-start" data-id="element-59" data-mp="2u55xqpe4fbza">
              <Button href={FANVUE_PROFILE_URL} variant="secondary" className="w-full lg:w-auto" data-id="element-60" data-mp="3htz136x2om3x">
                <span data-id="element-61" data-mp="3mqz5lde9xgsx">{t('bio.cta')}</span>
              </Button>
            </div>
          </div>

          {/* Image with Artistic Overlay */}
          <div className="order-1 lg:order-2 animate-fade-in-delay-1" data-id="element-62" data-mp="3cu49f15h3sht">
            <div className="relative group" data-id="element-63" data-mp="1wh5lbwvgwtdc">
              {/* Glow Effect */}
              <div className="absolute -inset-6 bg-gradient-to-br from-[#C5A028]/20 via-transparent to-transparent rounded-sm blur-3xl opacity-60" data-id="element-64" data-mp="1wj8mnd22m8xd" />

              {/* Image Container */}
              <div className="relative overflow-hidden rounded-sm" data-id="element-65" data-mp="2hp7zqhg71296">
                <img src="https://cdn.magicpatterns.com/uploads/pUXVahmqVccsp1oLQ6FBMM/IMG_6519.JPG.jpg" alt="Alexaaa Narvaez - Modelo Profesional" className="relative w-full aspect-[3/4] object-cover" style={{
                filter: 'brightness(0.95) contrast(1.05)'
              }} data-id="element-66" data-mp="2cvmy8ffe5q58" />

                {/* Lighter Overlay for Better Visibility */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/10" data-id="element-67" data-mp="2qntbntr5tj0z" />

                {/* Editorial Frame */}
                <div className="absolute inset-0 border border-white/10" data-id="element-68" data-mp="2lnx8txu77xn0" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}